// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3ba2b128","732":"f5b6ac46","977":"16569d60"}[chunkId] + ".chunk.js";
};